export default __webpack_public_path__ + "static/media/goldtick.6180a44c.svg";